import { render, staticRenderFns } from "./ShareOppRewardsDialog.vue?vue&type=template&id=2f94c91d"
import script from "./ShareOppRewardsDialog.vue?vue&type=script&lang=ts"
export * from "./ShareOppRewardsDialog.vue?vue&type=script&lang=ts"
import style0 from "./ShareOppRewardsDialog.vue?vue&type=style&index=0&id=2f94c91d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports